<template>
  <el-card shadow="never">
    <div slot="header" class="card-header">
      <span>我的页面设置</span>
    </div>

    <el-form ref="formRef" :model="form" :rules="rules" label-width="120px" class="style-form">
      <el-form-item label="顶部背景色" prop="headerBgColor">
        <div class="color-row">
          <el-input v-model.trim="form.headerBgColor" placeholder="例如：#184f39" />
          <input v-model="form.headerBgColor" class="color-picker" type="color" />
        </div>
        <div class="helper-text">建议填写十六进制颜色值，例如 `#184f39`。</div>
      </el-form-item>
    </el-form>

    <div class="preview-card">
      <div class="preview-header" :style="{ background: form.headerBgColor || '#184f39' }">
        <div class="preview-avatar"></div>
        <div class="preview-meta">
          <div class="preview-name">茶舍茶友</div>
          <div class="preview-badge">茶友会员</div>
        </div>
      </div>
      <div class="preview-content">这里是“我的”页面顶部区域预览。</div>
    </div>

    <div class="footer-actions">
      <el-button :loading="loading" @click="loadData">重置</el-button>
      <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
    </div>
  </el-card>
</template>

<script>
import { getProfileStyle, saveProfileStyle } from '../../api/admin'

const defaultForm = () => ({
  headerBgColor: '#184f39'
})

export default {
  data() {
    return {
      form: defaultForm(),
      loading: false,
      saving: false,
      rules: {
        headerBgColor: [
          { required: true, message: '请输入顶部背景色', trigger: 'blur' },
          {
            pattern: /^#([0-9a-fA-F]{6})$/,
            message: '请填写正确的十六进制颜色值，例如 #184f39',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const data = await getProfileStyle()
        this.form = {
          headerBgColor: data.headerBgColor || '#184f39'
        }
      } catch (error) {
        this.$message.error(error?.message || '页面设置加载失败')
      } finally {
        this.loading = false
      }
    },
    async submit() {
      try {
        await this.$refs.formRef.validate()
      } catch (error) {
        return
      }
      this.saving = true
      try {
        await saveProfileStyle(this.form)
        this.$message.success('页面设置已保存')
      } catch (error) {
        this.$message.error(error?.message || '页面设置保存失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.card-header {
  font-weight: 600;
}

.style-form {
  max-width: 720px;
}

.color-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.color-picker {
  width: 52px;
  height: 40px;
  padding: 0;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background: #fff;
}

.helper-text {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
}

.preview-card {
  width: 360px;
  margin-top: 24px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  border-radius: 20px;
  background: #fafaf9;
}

.preview-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 28px 20px 54px;
}

.preview-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #f1f5f9;
  border: 3px solid rgba(255, 255, 255, 0.55);
}

.preview-meta {
  color: #fff;
}

.preview-name {
  font-size: 16px;
  font-weight: 700;
}

.preview-badge {
  display: inline-block;
  margin-top: 8px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  font-size: 12px;
}

.preview-content {
  margin: -24px 16px 16px;
  padding: 18px 16px;
  border-radius: 16px;
  background: #fff;
  color: #606266;
  box-shadow: 0 8px 20px rgba(33, 28, 22, 0.06);
}

.footer-actions {
  margin-top: 24px;
}
</style>
